// @ts-strict-ignore
import Modal from 'src/components/modals/modal';
import { useSelector } from 'src/store/store';
import SignupBox from 'src/modules/shared/modal/components/signup/signupBox';
import { ShowSignupModal } from 'src/modules/shared/modal/actions';
export default function SignupModal() {
  const {
    community,
    redirectPage,
    onSignupSuccess
  } = useSelector(({
    modal
  }) => (modal.modalProps as ShowSignupModal));
  return <Modal customMaxWidth={'390px'} hasCloseButton={false} responsive={false} title="" data-sentry-element="Modal" data-sentry-component="SignupModal" data-sentry-source-file="signupModal.tsx">
      <SignupBox redirectPage={redirectPage} signupCommunity={community} onSignupSuccess={onSignupSuccess} data-sentry-element="SignupBox" data-sentry-source-file="signupModal.tsx" />
    </Modal>;
}